import { queryParam } from 'apps/utility/queryParams'
import { getCookieByName } from 'js/bankrate-utilities'

export default function getPid() {
  if (queryParam('pid')) return queryParam('pid')

  const brmp = getCookieByName('brmp')
  const pid = brmp ? JSON.parse(decodeURIComponent(brmp)).pid.p : null

  return pid ? pid : 'br3'
}

export function getAttrPid() {
  const attr = JSON.parse(decodeURIComponent(getCookieByName('attr')))
  if (attr && attr.attr_pid) {
    return attr.attr_pid
  }

  return null
}
